(ns ncr.auth
  (:require
   [cljs.core.async :as async :refer [<!] :refer-macros [go]]
   [cljs.core.async.interop :refer-macros [<p!]]
   [clojure.core.match :refer [match]]
   [clojure.string :as str]
   [goog.url :as gu]
   [cljs-http.client :as http]
   [ncr.etc.util :as u]
   [ncr.sysinfo :as sysinfo]
   [lambdaisland.glogi :as log]
   [uix.core.alpha :as uix]
   [ncr.widgets.core :as w]
   [ncr.etc.pubsub :as ps]
   [ncr.amplitude :as amp]
   ["keycloak-js$default" :as kc]))

(uix/defcontext *context*)

(defonce keycloak
  (atom nil))

(def client-id "neckar-ui-web")
(def demo-login "demo@neckar.io")
(def demo-password "neckar")

(def ^:private STORE-KEY "auth-cache")

(defn- read-store []
  (some-> (js/localStorage.getItem STORE-KEY) u/transit-read))

(defn- write-store [v]
  (js/localStorage.setItem STORE-KEY (u/transit-write v)))

(defn- make-keycloak [url realm]
  (let
    [^js keycloak
     (kc.
       #js
        {"realm" realm
         "clientId" client-id
         "url" url})]

    (set! (.-onAuthSuccess keycloak)
      (fn []
        (let [email (-> keycloak .-tokenParsed .-email)]
          (when (not= email demo-login)
            (amp/set-user-id! email)))

        (log/info :what :auth :status :success)
        (ps/pub! [::auth-success])))

    (set! (.-onAuthError keycloak)
      (fn []
        (log/error :what :auth :status :error)
        (ps/pub! [::auth-error])))

    keycloak))

; macros like `async/go` or `async.interop/<p!` are not working well with `^js` annotation,
; so we have to use helpers like these

(defn- kc-authenticated? [^js kc]
  (and kc (.-authenticated kc)))

(defn- kc-get-token [^js kc]
  (.-token kc))

(defn- kc-get-state [^js kc]
  {:token (.-token kc)
   :idToken (.-idToken kc)
   :refreshToken (.-refreshToken kc)})

(defn- kc-update-token [^js kc]
  (.updateToken kc 10))

(defn- kc-init [^js kc params]
  (.init kc
    (clj->js
      (merge
        {"onLoad" "login-required"
         "enableLogging" true
         "responseMode" "query"}
        (when-not (u/query-string-param "demo")
          (read-store))
        params))))

(defn c-with-authenticated [body]
  (let
    [^js url (gu/resolveUrl (str (.. js/window -location -href)))
     hostname (.-hostname url)
     session
     (ps/sub-reducer-map! :undefined
       {::auth-success
        (fn [_ _]
          :success)
        ::auth-error
        (fn [_ _]
          :error)})]

    (uix/with-effect [hostname]
      ; https://keycloak.discourse.group/t/keycloak-redirect-uri-issue/13049
      (go
        (u/error-m
          [server-info (get (<! sysinfo/info) :server)
           {:keys [url realm]} (:keycloak server-info)
           url (str/replace url #"/+$" "")

           kc
           (or @keycloak
             (reset! keycloak (make-keycloak url realm)))]

          (if (kc-authenticated? kc)
            (ps/pub! [::auth-success])
            (kc-init kc
              (when (u/query-string-param "demo")
                (match
                  (<!
                    (http/post (u/format "%s/realms/%s/protocol/openid-connect/token" url realm)
                      {:form-params
                       {"client_id" client-id
                        "grant_type" "password"
                        "username" demo-login
                        "password" demo-password}}))
                  {:status 200 :body {:access_token access_token :refresh_token refresh_token}}
                  {"token" access_token
                   "refreshToken" refresh_token
                   "checkLoginIframe" false}
                  _
                  nil)))))))

    (match @session
      :success
      (let [^js kc @keycloak]
        (uix/context-provider
          [*context*
           {:email (-> kc .-tokenParsed .-email)}]
          body))

      :error
      [w/c-bare-status "Login error"]

      :undefined
      [w/c-bare-status "Login..."])))

(defn signout! []
  (js/localStorage.removeItem STORE-KEY)
  (when-let [^js kc @keycloak]
    (.logout kc #js {"redirectUri" (-> js/window .-origin)})))

(defn account-management! []
  (when-let [^js kc @keycloak]
    (.accountManagement kc)))

(defn token []
  (go
    (let [_ (<p! (kc-update-token @keycloak))]
      (when-not (u/query-string-param "demo")
        (write-store (kc-get-state @keycloak)))
      (kc-get-token @keycloak))))
